import animationData from '../screenassets/lottiefiles/loading.json';
import Lottie from "lottie-react";

function Loading() {
    return (
        <div className='d-flex justify-content-center align-items-center ' style={{height:"100vh"}}>
            <div style={{ height: '300px', width: '300px' }}>
                {/* <Player autoplay loopsrc={animationData}style={{ height: '300px', width: '300px' }}/> */}
                <Lottie animationData={animationData} loop={true} />
            </div>
        </div>
    )
}

export default Loading
